import { atom } from 'recoil';

import { getUserInfo } from '../../Common/getUserInfo';

const twoFactorLogin = atom({
  key: 'twoFactorLogin',
  default: 0
});

const userInfo = atom({
  key: 'userInfo',
  default: getUserInfo(),
  effects_UNSTABLE: [
    ({ setSelf, onSet }) => {
      // Initialize from localStorage
      const savedValue = localStorage.getItem('user');
      if (savedValue != null) {
        try {
          const parsed = JSON.parse(savedValue);
          setSelf(parsed);
        } catch (e) {
          console.error('Failed to parse user from localStorage:', e);
        }
      }

      // Subscribe to state changes and persist to localStorage
      onSet((newValue) => {
        if (newValue === null) {
          localStorage.removeItem('user');
        } else {
          localStorage.setItem('user', JSON.stringify(newValue));
        }
      });
    },
  ],
});

const refetchToken = atom({
  key: 'refetchToken',
  default: 0
});

const forceLogin = atom({
  key: 'forceLogin',
  default: 0
});

const updateUser = atom({
  key: 'updateUser',
  default: 0
});

export { twoFactorLogin, userInfo, refetchToken, forceLogin, updateUser };
